/**
 * Support for copy-pasting
 * @module embed/clipboard
 */

import Clipboard from 'clipboard';
import Tooltip from 'tooltip.js';

const SELECTOR = '.js-clipboard';
const CLASS_WITH_CLIPBOARD = 'bcs-withClipboard';
const EVENT_CLIPBOARD_SUCCESS = 'clipboardsuccess';
const EVENT_CLIPBOARD_ERROR = 'clipboarderror';

export default function setupClipboard() {
  if (Clipboard.isSupported()) {
    document.documentElement.classList.add(CLASS_WITH_CLIPBOARD);
  }
  const clipboard = new Clipboard(SELECTOR);
  // Dispatch appropriate CustomEvents to provide feedback
  clipboard.on('success', e => {
    const event = new CustomEvent(EVENT_CLIPBOARD_SUCCESS, {
      bubbles: true,
      cancelable: true
    });
    e.trigger.dispatchEvent(event);
  });
  clipboard.on('error', e => {
    const event = new CustomEvent(EVENT_CLIPBOARD_ERROR, {
      bubbles: true,
      cancelable: true
    });
    e.trigger.dispatchEvent(event);
  });

  let currentTooltip;
  let clearTooltipTimeout;
  document.addEventListener(EVENT_CLIPBOARD_SUCCESS, event => {
    if (!event.defaultPrevented) {
      disposeCurrentTooltip();
      currentTooltip = new Tooltip(event.target, {
        title: 'Copied!',
        placement: 'bottom',
        // We're controlling when the tooltip appears
        trigger: 'manual',
        // Add tooltip to body so it is not affected by hidden overflow
        container: event.target.closest('.bcs-slide'),
        // Update template to match bootstrap's classes
        template: `
        <div class="tooltip show bs-tooltip-auto" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>
        `
      }).show();

      // TODO: Revisit accessibility maybe, not sure automatic disappearance is that great :/
      clearTooltipTimeout = setTimeout(() => {
        currentTooltip.dispose();
      }, 3000);
    }
  });

  document.addEventListener(EVENT_CLIPBOARD_ERROR, event => {
    if (!event.defaultPrevented) {
      disposeCurrentTooltip();
      currentTooltip = new Tooltip(event.target, {
        title: 'Sorry, the copy failed',
        placement: 'bottom',
        trigger: 'manual',
        container: event.target.closest('.bcs-slide'),
        template: `
        <div class="tooltip tooltip--danger show bs-tooltip-auto" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>
        `
      }).show();

      // TODO: Revisit accessibility maybe, not sure automatic disappearance is that great :/
      clearTooltipTimeout = setTimeout(() => {
        currentTooltip.dispose();
      }, 3000);
    }
  });

  function disposeCurrentTooltip() {
    if (currentTooltip) {
      currentTooltip.dispose();
      currentTooltip.reference.removeAttribute('aria-describedby');
      currentTooltip = null;
      clearTimeout(clearTooltipTimeout);
    }
  }
}



// WEBPACK FOOTER //
// ./app/webpack/javascripts/embed/clipboard.js